import controller from './client-controller';
import template from './client.html';

const ClientComponent = {
    bindings: {
        client: '<',
        groupList: '<',
        onDelete: '&',
        onUpdate: '&',
        surveyTemplateList: '<',
        userList: '<'
    },
    controller,
    template,
};

export default ClientComponent;



// WEBPACK FOOTER //
// ./app/components/client-admin/client/client-component.js